
export interface IMetricParameters {

  MetricParameterId: string;

  Sources: number[];    // WB_Source_ID

  PlanningCustomers: number[] // WB_CUST_ID
  SourceCustomers: number[]   // WB_CUST_ID

  FinishedProducts: number[]    // WB_PROD_ID
  OrderFinishedProduct?: number[] // WB_PROD_ID_ORDER
  ConsumerProductUPCs: string[]  // Consumer UPCs

  SalesArea?: number[] // WB_SALESAREA_ID
  SalesOrg?: number[] // WB_SALESORG_ID

  ConsumptionAdjustmentsPGs: number[] // WB_CNSPG_ID
  ProductGroups?: number[]

  InStoreStartDt: Date
  InStoreEndDt: Date
  ShipmentStartDt: Date
  ShipmentEndDt: Date

  bIncludeAdjustments: boolean
  bIncludeEDLPSplit: boolean

  bCalculateIntersection: boolean
  Int_InStoreStartDt: Date
  Int_InStoreEndDt: Date
  Int_ShipmentStartDt: Date
  Int_ShipmentEndDt: Date

  //
}

export interface IMetricParameterSet {
  [id: string]: IMetricParameters
}


export interface IMetrics {

  clone(): IMetrics
  subtract(aMetrics: IMetrics): void
  add(aMetrics: IMetrics): void
  scaleBy(aScaleFactor: number): void

  IntersectionMetrics: IMetrics
  CalcError: any

  // copy interface IwbMetric { ... same names, exclude SPEND,  Compound Metrics & adjacent metrics
  "CNSMP_BASE_UNITS"?: number;
  "CNSMP_BASE_WT"?: number;
  "CNSMP_BASE_STAT"?: number;
  "CNSMP_BASE_LISTSLS"?: number;
  "CNSMP_BASE_NETLISTSLS"?: number;
  "CNSMP_BASE_RTLSLS"?: number;
  "CNSMP_BASE_PRFTCNTRB"?: number;
  "CNSMP_EDLP_UNITS"?: number;
  "CNSMP_EDLP_WT"?: number;
  "CNSMP_EDLP_STAT"?: number;
  "CNSMP_EDLP_LISTSLS"?: number;
  "CNSMP_EDLP_NETLISTSLS"?: number;
  "CNSMP_EDLP_RTLSLS"?: number;
  "CNSMP_EDLP_PRFTCNTRB"?: number;
  "CNSMP_INCR_UNITS"?: number;
  "CNSMP_INCR_WT"?: number;
  "CNSMP_INCR_STAT"?: number;
  "CNSMP_INCR_LISTSLS"?: number;
  "CNSMP_INCR_NETLISTSLS"?: number;
  "CNSMP_INCR_RTLSLS"?: number;
  "CNSMP_INCR_PRFTCNTRB"?: number;
  "CNSMP_TOTAL_UNITS"?: number;
  "CNSMP_TOTAL_WT"?: number;
  "CNSMP_TOTAL_STAT"?: number;
  "CNSMP_TOTAL_LISTSLS"?: number;
  "CNSMP_TOTAL_NETLISTSLS"?: number;
  "CNSMP_TOTAL_RTLSLS"?: number;
  "CNSMP_TOTAL_PRFTCNTRB"?: number;
  "CNSMP_PROMO_UNITS"?: number;
  "CNSMP_PROMO_WT"?: number;
  "CNSMP_PROMO_STAT"?: number;
  "CNSMP_PROMO_LISTSLS"?: number;
  "CNSMP_PROMO_NETLISTSLS"?: number;
  "CNSMP_PROMO_RTLSLS"?: number;
  "CNSMP_PROMO_PRFTCNTRB"?: number;
  "CNSMP_NONPROMO_UNITS"?: number;
  "CNSMP_NONPROMO_WT"?: number;
  "CNSMP_NONPROMO_STAT"?: number;
  "CNSMP_NONPROMO_LISTSLS"?: number;
  "CNSMP_NONPROMO_NETLISTSLS"?: number;
  "CNSMP_NONPROMO_RTLSLS"?: number;
  "CNSMP_NONPROMO_PRFTCNTRB"?: number;
  "MERCH_FEATUREONLY_ACV_N"?: number;
  "MERCH_DISPLAYONLY_ACV_N"?: number;
  "MERCH_FEATUREDISPLAY_ACV_N"?: number;
  "MERCH_TPRONLY_ACV_N"?: number;
  "MERCH_PROMOTED_ACV_N"?: number;
  "MERCH_DIST_ACV_N"?: number;
  "MERCH_ACV_D"?: number;
  "MERCH_FEATUREONLY_UNITS"?: number;
  "MERCH_DISPLAYONLY_UNITS"?: number;
  "MERCH_FEATUREDISPLAY_UNITS"?: number;
  "MERCH_TPRONLY_UNITS"?: number;
  "MERCH_PROMOTED_UNITS"?: number;
  "SHIPMENT_ORDER_QTY"?: number,
  "SHIPMENT_BUOM_QTY"?: number,
  "SHIPMENT_UNITS"?: number;
  "SHIPMENT_WT"?: number;
  "SHIPMENT_STAT"?: number;
  "SHIPMENT_LISTSLS"?: number;
  "SHIPMENT_NETLISTSLS"?: number;
  "SHIPMENT_PRFTCNTRB"?: number;
  "RETURN_ORDER_QTY"?: number,
  "RETURN_BUOM_QTY"?: number,
  "RETURN_UNITS"?: number;
  "RETURN_WT"?: number;
  "RETURN_STAT"?: number;
  "RETURN_LISTSLS"?: number;
  "RETURN_NETLISTSLS"?: number;
  "RETURN_PRFTCNTRB"?: number;

  // computed measures
  "LIST_PRICE"?: number;
  "LIFT_BYUNITS_PCNT"?: number;
  "LIFT_BYWT_PCNT"?: number;
  "VCM_CNSMP_INCR_PCNT"?: number;
  "VCM_CNSMP_PCNT"?: number;
  "VCM_SHIP_PCNT"?: number;
  "RETAILER_BASE_PRICE"?: number;
  "RETAILER_PROMOTED_PRICE"?: number;
  "RETAILER_AVG_PRICE"?: number;
  "MERCH_FEATUREONLY_ACV_PCNT"?: number;
  "MERCH_DISPLAYONLY_ACV_PCNT"?: number;
  "MERCH_FEATUREDISPLAY_ACV_PCNT"?: number;
  "MERCH_TPRONLY_ACV_PCNT"?: number;
  "MERCH_PROMOTED_ACV_PCNT"?: number;
  "MERCH_DIST_ACV_PCNT"?: number;
  "CNSMP_SYND_BASE_UNITS"?: number;
  "CNSMP_SYND_BASE_WT"?: number;
  "CNSMP_SYND_BASE_STAT"?: number;
  "CNSMP_SYND_BASE_LISTSLS"?: number;
  "CNSMP_SYND_BASE_NETLISTSLS"?: number;
  "CNSMP_SYND_BASE_RTLSLS"?: number;
  "CNSMP_SYND_BASE_PRFTCNTRB"?: number;

  [id: string]: any
}

export interface IMetricsSet {
  [id: string]: IMetrics
}

export interface IMetricDetailRow {
  Key: string

  PlanningCustomer?: number
  SourceCustomer?: number
  Product?: number
  ConsumerProductUPC?: string,
  Source?: number,
  Date: Date

  Metrics: IMetrics
}

export interface IMetricDetails {

  DetailRows: IMetricDetailRow[]

  CalcError: any

  [id: string]: any
}


export interface IMetricDetailsSet {
  [id: string]: IMetricDetails
}

export enum DetailAttributes {
  PlanningCustomer = "PlanningCustomer",
  SourceCustomer   = "SourceCustomer",
  Product          = "Product",
  ConsumerUPC      = "ConsumerProduct",
  Date             = "Date",
  Source           = "Source"
}

export interface IMetricDetailsOptions {
  Attributes: DetailAttributes[]
}

export interface IMetricService {
  calculateMetric(metric_parameter: IMetricParameters):Promise<IMetrics>
  calculateMetricSet(metric_parameter_set: IMetricParameterSet): Promise<IMetricsSet>

  calculateMetricDetails(metric_parameter: IMetricParameters, detailOptions: IMetricDetailsOptions):Promise<IMetricDetails>
  calculateMetricDetailsSet(metric_parameter_set: IMetricParameterSet, detailOptions: IMetricDetailsOptions): Promise<IMetricDetailsSet>

  calculateMetricUnion(metric_parameters: IMetricParameters[]):Promise<IMetrics[]>
  calculateMetricUnionDetails(metric_parameters: IMetricParameterSet, detailOptions: IMetricDetailsOptions):Promise<IMetricDetailsSet>

}



